import {
	RiArrowGoBackLine,
	RiArrowGoForwardLine,
	RiBold,
	RiCheckboxLine,
	RiCodeSSlashLine,
	RiItalic,
	RiLink,
	RiListOrdered,
	RiListUnordered,
	RiStrikethrough,
	RiTableLine,
	RiUnderline,
} from "@remixicon/react";
import { KEYS } from "platejs";
import { useEditorReadOnly, useEditorRef } from "platejs/react";
import { insertBlock } from "../transforms";
import { MarkToolbarButton } from "./mark-toolbar-button";
import { ToolbarButton, ToolbarGroup } from "./toolbar";
import { TurnIntoToolbarButton } from "./turn-into-toolbar-button";

export function FixedToolbarButtons() {
	const readOnly = useEditorReadOnly();
	const editor = useEditorRef();

	if (readOnly) return null;

	return (
		<div className="flex w-full">
			<ToolbarGroup>
				<ToolbarButton tooltip="Undo" onClick={() => editor.undo()}>
					<RiArrowGoBackLine />
				</ToolbarButton>
				<ToolbarButton tooltip="Redo" onClick={() => editor.redo()}>
					<RiArrowGoForwardLine />
				</ToolbarButton>
			</ToolbarGroup>

			<ToolbarGroup>
				<TurnIntoToolbarButton />
			</ToolbarGroup>

			<ToolbarGroup>
				<MarkToolbarButton nodeType={KEYS.bold} tooltip="Bold (Cmd+B)">
					<RiBold />
				</MarkToolbarButton>
				<MarkToolbarButton nodeType={KEYS.italic} tooltip="Italic (Cmd+I)">
					<RiItalic />
				</MarkToolbarButton>
				<MarkToolbarButton nodeType={KEYS.underline} tooltip="Underline (Cmd+U)">
					<RiUnderline />
				</MarkToolbarButton>
				<MarkToolbarButton nodeType={KEYS.strikethrough} tooltip="Strikethrough">
					<RiStrikethrough />
				</MarkToolbarButton>
				<MarkToolbarButton nodeType={KEYS.code} tooltip="Code (Cmd+E)">
					<RiCodeSSlashLine />
				</MarkToolbarButton>
			</ToolbarGroup>

			<ToolbarGroup>
				<ToolbarButton tooltip="Bulleted list" onClick={() => insertBlock(editor, KEYS.ul)}>
					<RiListUnordered />
				</ToolbarButton>
				<ToolbarButton tooltip="Numbered list" onClick={() => insertBlock(editor, KEYS.ol)}>
					<RiListOrdered />
				</ToolbarButton>
				<ToolbarButton tooltip="To-do list" onClick={() => insertBlock(editor, KEYS.listTodo)}>
					<RiCheckboxLine />
				</ToolbarButton>
			</ToolbarGroup>

			<ToolbarGroup>
				<ToolbarButton
					tooltip="Link"
					onClick={() => {
						const url = window.prompt("Enter URL:");
						if (url) {
							editor.tf.insertNodes(
								{ type: "a", url, children: [{ text: url }] },
								{ select: true },
							);
						}
					}}
				>
					<RiLink />
				</ToolbarButton>
				<ToolbarButton tooltip="Table" onClick={() => insertBlock(editor, KEYS.table)}>
					<RiTableLine />
				</ToolbarButton>
			</ToolbarGroup>
		</div>
	);
}
